export const FOOTER_ACTIVE_NO = 'FOOTER_ACTIVE_NO'